import { PageLayout } from 'components/PageLayout';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Redirect, useLocation } from 'react-router-dom';
import { useAuthState } from 'state/useAuthState';
import { MembershipPlanProvider } from 'features/membership/components/MembershipPlanProvider';
import { MembershipContent } from './MembershipContent';

export const Membership = (): JSX.Element => {
  const { t } = useTranslation();
  const {
    hasActiveMembership,
    isOrganizationUser,
    permissions: { canManageOrganization },
  } = useAuthState();
  const location = useLocation<{ fromRoute?: string }>();

  if (isOrganizationUser) {
    if (canManageOrganization) {
      return (
        <Redirect to={{ pathname: '/organization', state: location.state }} />
      );
    }
    return <Redirect to={{ pathname: '/', state: location.state }} />;
  }

  if (!hasActiveMembership) {
    return (
      <Redirect to={{ pathname: '/support_us/', state: location.state }} />
    );
  }

  const returnRoute = location.state?.fromRoute || '/';

  return (
    <PageLayout
      data-cname="MembershipPage"
      headerBarProps={{ title: t('membership.title'), action: returnRoute }}
    >
      <Helmet>
        <title>{t('membership.title')}</title>
      </Helmet>
      <MembershipPlanProvider>
        <MembershipContent />
      </MembershipPlanProvider>
    </PageLayout>
  );
};
